import PubSub from 'pubsub-js';
import ua from 'ua-parser-js';
import '../components/top/background/background';
import '../components/top/background/circle';
import '../components/top/anchorMenu/anchorMenu';
import '../components/top/anchorMenu/anchorQuery';
import '../components/top/contents/contents';
import '../components/top/footer/footer';
import '../components/top/footer/anchor';
import '../components/team/modal/modal';

const device = ua().device.type || 'pc';
$('html').attr('data-device', device);

const resize = () => {
    PubSub.publish('top.updateBackgroundCircle');
}

window.onresize = () => {
    resize();
}
resize();